import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {LpAssetReqRes} from '../../../assets/LpAssetReqRes.model';
import {LpFundReqRes} from '../../../funds/LpFundReqRes.model';
import AreaUnit from 'src/app/shared/enums/AreaUnit.enum';
import {isNullOrUndefined} from 'src/app/shared/TerraUtils';
import HoldingDiscriminator from '../../../../shared/enums/HoldingDiscriminator.enum';

@Component({
  selector: 'terra-holding-project-information',
  templateUrl: './holding-project-information.component.html',
  styleUrls: ['./holding-project-information.component.scss', '../../../styles/holding/holding-page-shared.scss']
})
export class HoldingProjectInformationComponent implements OnInit {

  // Consts
  AreaUnit = AreaUnit;
  isNullOrUndefined = isNullOrUndefined;

  // enums
  HoldingDiscriminator = HoldingDiscriminator;

  @Input() holding: LpAssetReqRes | LpFundReqRes;
  @Output() toDisplay = new EventEmitter<boolean>();
  holdingAsAsset: LpAssetReqRes;
  holdingDiscriminator: HoldingDiscriminator;

  constructor() { }

  ngOnInit() {
    this.holdingAsAsset = this.holding as LpAssetReqRes;
    this.holdingDiscriminator = this.holding.discriminator;
    this.displayData();
  }

  /** Display details only if at least one item has a value to display. */
  displayData() {
    if (this.holding.discriminator === HoldingDiscriminator.Asset) {
      if (!this.holdingAsAsset) {
        this.holdingAsAsset = this.holding as LpAssetReqRes;
      }

      this.toDisplay.next(!isNullOrUndefined(this.holdingAsAsset.plannedCostsToDate)
                        || !isNullOrUndefined(this.holdingAsAsset.actualCostsToDate)
                        || !isNullOrUndefined(this.holdingAsAsset.constructionStartDate)
                        || !isNullOrUndefined(this.holdingAsAsset.constructionEndDate)
                        || !isNullOrUndefined(this.holdingAsAsset.constructionEndDate)
                        || this.holdingAsAsset.projectBudgetOriginal
                        && (isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.acquisition)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.hardCost)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.softCost)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.financing)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.totalCosts)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.totalCostsPerGrossAreaUnit)
                          || !isNullOrUndefined(this.holdingAsAsset.projectBudgetOriginal.totalCostsPerNetAreaUnit))
        );

    }

    this.toDisplay.next(this.holding.projectBudgetOriginal
                    && (isNullOrUndefined(this.holding.projectBudgetOriginal.acquisition)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.hardCost)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.softCost)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.financing)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.totalCosts)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.totalCostsPerGrossAreaUnit)
                      || !isNullOrUndefined(this.holding.projectBudgetOriginal.totalCostsPerNetAreaUnit))
      );
  }
}
